'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';
import styled from 'styled-components';

import air from '@/public/images/services/air_conditioning/air.png';
import availablity from '@/public/images/services/air_conditioning/availablity.png';
import clear from '@/public/images/services/air_conditioning/clear.png';
import control from '@/public/images/services/air_conditioning/control.png';
import energy from '@/public/images/services/air_conditioning/energy.png';
// import humadity from '@/public/images/services/air_conditioning/humadity.png';
import licensed from '@/public/images/services/ac_installation/licensed.png';

const data = {
  title: 'Our Air Conditioning Services in San Diego',
  description:
    'Our skilled team delivers expert air conditioning services in San Diego, keeping your home or business comfortable, no matter the season. Enjoy the peace of mind that comes with stepping into a perfectly climate-controlled environment.',
  image: image,
  offer_title: '',
  offer_data: [
    {
      title: 'Air Conditioning Repair:',
      description:
        'Air conditioning repair in San Diego addresses a range of issues, from inadequate cooling and unusual sounds to frequent cycling and thermostat malfunctions. Problems like water leaks, improper sizing, poor placement, faulty ductwork, electrical issues, or incorrect refrigerant levels can all compromise your system’s performance. Quick AC repairs in San Diego are essential to keep your AC running smoothly and prevent further damage.',
      list: [],
    },

    {
      title: 'Air Conditioning Installation: ',
      description:
        'Explore expert solutions for AC installation in San Diego, including energy-efficient units and smart thermostats, all designed to keep your home cool and comfortable. For homes without ductwork, our team also specializes in <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">ductless mini splits in San Diego, CA</a>, providing targeted cooling with flexible installation options.',
      list: [
        { title: 'New air conditioning system ', description: '' },
        { title: 'Central air ', description: '' },
        { title: 'Ductless AC system   ', description: '' },
        { title: 'Heat pump for cooling ', description: '' },
        { title: 'Smart thermostat  ', description: '' },

        { title: 'Zoning system  ', description: '' },
        { title: 'Programmable thermostat ', description: '' },
        { title: 'Energy-efficient AC  ', description: '' },
        { title: 'Air filtration system  ', description: '' },
        { title: 'Whole-house dehumidifier  ', description: '' },
      ],
    },
    {
      title: 'Air Conditioning Replacement: ',
      description:
        'If your AC is over a decade old, prone to frequent malfunctions, or demanding costly repairs, it might be the right moment to consider a replacement. Older units typically lack the latest energy-efficient technology, leading to higher utility bills and poor performance. Switching to a modern, energy-efficient system ensures enhanced comfort and reduces costs over time.',
      list: [],
    },
    {
      title: 'Air Conditioning Maintenance: ',
      description:
        'Regular air conditioning upkeep is essential for maintaining optimal performance and efficiency. Issues like clogged filters, dirty coils, worn-out belts, and refrigerant leaks can lower performance and cause expensive repairs. Regular maintenance boosts cooling capacity and energy efficiency, helping you avoid costly breakdowns.',
      list: [],
    },
  ],
  banner_title: ``,
  banner_description: `We offer expert AC solutions to keep your home cool and comfortable, ensuring efficiency and peace of mind. Reach out to get a quote and schedule an appointment at a convenient time.`,
  banner_with_button: true,
  why_title: '',

  why_description: ``,
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Why Choose Tytum for Air Conditioning Services?',
      description:
        'When it comes to AC installation, Tytum is a go-to AC contractor in San Diego for both residential and commercial cooling needs. What makes us stand out:',
      image: null,
      items: [
        {
          title: 'Licensed & Certified AC Contractors',
          image: licensed,
          description:
            'Our company is a fully certified and licensed AC contractor in San Diego. By choosing Tytum’s technicians, you get an accurate diagnosis as we get to the core of issues with your AC system. We comply with relevant California regulations and offer warranty protection to all our customers.',
        },
        {
          title: 'Better Indoor Air Quality',
          image: air,
          description:
            'Our AC services help reduce allergens, dust, and pollutants, providing you and your family with cleaner, healthier air.',
        },
        {
          title: 'Energy Efficiency Upgrades',
          image: energy,
          description:
            'We optimize your AC system to consume less energy while maintaining excellent performance, saving you money on utility bills without sacrificing comfort.',
        },
        {
          title: 'Enhanced Comfort Control',
          image: control,
          description:
            'Whether it’s eliminating hot spots or keeping temperatures consistent, our expert solutions improve your indoor climate.',
        },
        /* {
          title: 'Humidity Regulation',
          image: humadity,
          description:
            'Efficient AC operation helps control humidity, reducing issues like mold growth and creating a more comfortable environment.',
        }, */
        {
          title: 'Same-Day Service Availability',
          image: availablity,
          description:
            "AC problems can't wait. We offer same-day service to restore your comfort without delay.",
        },
        {
          title: 'Clear Pricing and Satisfaction Guarantee',
          image: clear,
          description:
            'With upfront pricing and a commitment to complete customer satisfaction, you can count on us to provide top-notch air conditioning service in San Diego and peace of mind.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Signs You Need Expert AC Service in San Diego',
      description:
        'Your AC system plays a vital role in your comfort, and timely repairs can prevent larger problems in the future. For homeowners seeking reliable <a href="https://tytum.com/services/heating-and-air">heating and AC repair in San Diego</a>, our team provides trusted solutions. Watch out for these signs:',
      image: null,
      items: [
        {
          title: 'Weak Airflow',
          image: null,
          description:
            'If your AC isn’t pushing air effectively, clogged filters, blocked ducts, or fan issues may be to blame. This requires professional inspection and repair.',
        },
        {
          title: 'Unusual Noises',
          image: null,
          description:
            'Loud sounds such as banging, buzzing, or rattling could point to loose parts, motor issues, or other mechanical problems.',
        },
        {
          title: 'Inconsistent Cooling',
          image: null,
          description:
            'Uneven temperatures in your home could indicate a faulty thermostat, duct leaks, or low refrigerant levels, all of which need professional attention.',
        },
        /* {
          title: 'Rising Energy Costs',
          image: null,
          description:
            'Unexplained increases in your energy bills could indicate that your AC system is straining to perform, often due to worn-out components or reduced efficiency.',
        }, */
        {
          title: 'Frequent Cycling + Rising Energy Costs',
          image: null,
          description:
            'If your AC frequently cycles on and off, it could be due to a malfunctioning sensor or an incorrect system size for your home.<br /><br />Unexplained increases in your energy bills could indicate that your AC system is straining to perform, often due to worn-out components or reduced efficiency.',
        },
        {
          title: 'Signs of Leaks or Moisture Around the Unit',
          image: null,
          description:
            'The presence of water or refrigerant leaks around your system indicates a critical problem that requires prompt attention.',
        },
        {
          title: 'Strange Odors',
          image: null,
          description:
            'Odd smells from your AC often point to mold or bacterial buildup, or even wiring issues, all of which require expert handling.',
        },
      ],
      footerText: '',
    },
    {
      title: 'How Our AC Service Works in San Diego?',
      description:
        'At Tytum, we make it simple to get the air condition services in San Diego you need with a clear, easy process:',
      image: null,
      items: [
        {
          title: '1. Contact Us',
          image: null,
          description:
            'Call or use our online form to request service. Tell us about your cooling concerns, and we’ll schedule a convenient appointment.',
        },
        {
          title: '2. Schedule a Technician',
          image: null,
          description:
            'A certified technician will arrive on time, inspect your AC system, and identify the issue.',
        },
        {
          title: '3. Receive a Solution',
          image: null,
          description:
            'We’ll explain the problem and recommend the best next steps—repair, maintenance, or installation—so you can make an informed decision.',
        },
        {
          title: '4. Expert Service Delivery',
          image: null,
          description:
            'Our technician will carry out the work with precision, ensuring your AC system operates reliably and efficiently. <br /><br /> If you have any questions or require additional support, our team is here for you every step of the way, even after the work is done. Trust Tytum for expert air conditioning service, repair, and professional <a href="https://tytum.com/services/heating-and-air/ac-installation">air conditioning installation in San Diego</a>. Get in touch with us today or request your free quote online!',
        },
        /* {
          title: '5. Follow-Up Support',
          image: null,
          description:
            'If you have any questions or require additional support, our team is here for you every step of the way, even after the work is done.',
        }, */
      ],
      footerText: '',
    },

    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      image: null,
      items: [
        {
          title: '✓ Why is my air conditioner running but not cooling?',
          image: null,
          description: (
            <>
              This could be caused by clogged filters, insufficient refrigerant
              levels, or an issue with the thermostat. Get in touch with us for
              dependable air condition service in San Diego to diagnose and
              resolve the issue.
            </>
          ),
        },
        {
          title: '✓ What is the cost of air conditioner servicing?',
          image: null,
          description: (
            <>
              The cost varies based on the service needed, whether it&apos;s
              routine maintenance or necessary repairs.{' '}
              <a href="https://tytum.com/company/contact">Contact us today</a>{' '}
              for a personalized quote for air conditioning maintenance services
              in San Diego.
            </>
          ),
        },
        {
          title: '✓ How long does AC maintenance take in San Diego?',
          image: null,
          description:
            'AC maintenance in San Diego that we perform at Tytum takes only up to 2 hours, depending on the condition of the system and when it was last checked and cleaned by specialists.',
        },
        {
          title: '✓ How often should I have my air conditioner serviced?',
          image: null,
          description:
            'Scheduling maintenance at least once a year is essential to avoid unexpected breakdowns and keep your system running efficiently. Regular servicing ensures reliable, long-lasting performance.',
        },
        {
          title: '✓ Can I schedule same-day AC repair in San Diego?',
          image: null,
          description: (
            <>
              Yes! We provide prompt, same-day air conditioner repair in San
              Diego to restore your comfort quickly.{' '}
              <a href="https://tytum.com/company/contact">Contact us now</a> to
              book a technician and restore your system to peak performance.
            </>
          ),
        },
      ],
      footerText: '',
    },
  ],
};

const AirConditioningPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="snowCircle">
        <MainSection
          label="Service Details"
          title="Air Conditioning Service & Repair in&nbsp;San&nbsp;Diego, CA"
          description="Is your AC system acting up? Do you need routine maintenance to keep it stable? At Tytum, we specialize in a full range of air conditioning services, including repairs of any complexity, replacements, and maintenance. Our technicians provide affordable, quick air conditioning service in San Diego, so your home stays comfortable year-round."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={
              <div>
                <ContentV2 data={data} />
              </div>
            }
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default AirConditioningPage;

export const StaticSection = styled.div`
  text-align: left;
  margin-bottom: 6rem;

  a {
    text-decoration: underline;
  }
`;
